import { writable } from 'svelte/store';
import { v4 as uuidv4 } from 'uuid';

let local_sheets = localStorage.getItem('sheets');
let user_sheets = local_sheets !== null ? JSON.parse(local_sheets) : [];

function createCheatsheets(sheets) {
	const { subscribe, update } = writable(sheets);

	function create(sheet) {
		sheet.id = uuidv4();
		user_sheets.push(sheet);
		localStorage.setItem('sheets', JSON.stringify(user_sheets));
	}

	function rm(target_id) {
		update(c => c.filter(sheets => sheets.id !== target_id));
		localStorage.setItem('sheets', JSON.stringify(user_sheets.filter(sheets => sheets.id !== target_id)));
	}

	function edit(updatedSheet) {
		let oldSheet = user_sheets.findIndex(i => i.id === updatedSheet.id);
		user_sheets[oldSheet] = updatedSheet;
		localStorage.setItem('sheets', JSON.stringify(user_sheets));
	}

	return {
		subscribe,
		rm,
		create,
		edit,
	};
}

export const cheatsheets = createCheatsheets(user_sheets);